angular.module('impactx.orderconfirmation').controller('OrderConfirmationBuyerListCtrl', [
    'selectedListItems',
    OrderConfirmationBuyerListCtrl
]);

function OrderConfirmationBuyerListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewOrderConfirmationBuyer'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/orderconfirmation/templates/orderconfirmationbuyerlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/orderconfirmation/listbuyer',
        id: "orderconfirmationbuyerlist",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "orderconfirmationbuyer/" + selectedListItems.getFirstSelectedItem().pohId;
    }
}